export default __webpack_public_path__ + "static/media/c12.3ad62158.jpg";